import React, { useState } from "react";
import { AWSMigrationEngineersFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const AWSMigrationEngineers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire skilled AWS migration engineers in India to seamlessly move your infrastructure to the cloud. Ensure secure, fast, and cost-effective AWS migration solutions."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire AWS Migration Engineers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-aws-migration-engineers"/>
<meta property="og:description" content="Hire skilled AWS migration engineers in India to seamlessly move your infrastructure to the cloud. Ensure secure, fast, and cost-effective AWS migration solutions."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire AWS Migration Engineers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire skilled AWS migration engineers in India to seamlessly move your infrastructure to the cloud. Ensure secure, fast, and cost-effective AWS migration solutions."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-aws-migration-engineers"/>
<title>Hire AWS Migration Engineers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className=" flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-10 ">
          <div className="lg:w-3/4 lg:text-left  ">
          <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire AWS Migration Engineers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg  leading-relaxed mb-3">
              Amazon Web Services is a collection of computing services that
              work together to build Amazon's cloud computing platform. AWS is
              known for offering enterprises a safe and scalable development
              environment to implement digital transformation. Large-scale
              enterprise applications can now be deployed thanks to it. With
              Ayanshtech's AWS developers, you'll never worry about setting up,
              maintaining, or improving your Web Applications' cloud
              infrastructure again.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $15/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a AWS Migration Engineer
            </button>
          </div>

          <div className="flex justify-center  mb-12 lg:mb-0 mt-5">
            <img
              src="\assets\images\headerSection\hireAWSMigrationEng\img1.png"
              alt="VoIP Business Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Mastery of Our AWS Migration Engineers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Our team of<a
    className="relative 
    before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
    before:h-[2px] before:w-0 before:bg-green-600 
    before:transition-all before:duration-300 
    hover:before:left-0 hover:before:w-full text-green-600 font-bold"
    href="https://ayanshtechnology.com/devops-aws"
  > AWS migration
  </a> certified engineers brings a wealth of
          expertise and a variety of services to help you smoothly transition to
          the cloud.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon1.png"
              alt="AWS infrastructure management icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Comprehensive AWS Infrastructure Setup and Management
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon2.png"
              alt="AWS architect expertise icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Cloud Architecture and Design by AWS Certified Experts
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon3.png"
              alt="AWS Cloud Practitioner icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Cloud Practitioner Professionals to Guide Your Migration
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="AWS Developer icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Certified AWS Developers for Seamless Cloud Solutions
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="AWS data migration icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Specialized in Secure and Efficient AWS Data Migration
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="AWS optimization icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              AWS Performance Optimization and Cost Efficiency
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Expert AWS Certified Engineers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Hire experienced AWS-certified engineers from Ayanshtech to propel
          your business’s digital transformation by utilizing the power of the
          cloud.
        </p>
      </div>

      <div className=" ">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hireAWSMigrationEng\img2.webp"
              alt="Laptop with graph"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Design, develop, and optimize cloud environments that are both
                  scalable and cost-efficient.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our AWS specialists are proficient in implementing
                  multi-tenant and single-tenant cloud solutions tailored to
                  your business needs.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  We help organizations leverage the full potential of AWS,
                  maximizing the benefits of open-source cloud technologies.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our AWS-certified engineers offer deep expertise in
                  customizing and developing cloud applications, optimizing your
                  infrastructure for performance and efficiency.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  We provide expert consultation for businesses seeking to
                  migrate their legacy systems to the cloud with minimal
                  disruption and maximum benefit.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our AWS-certified engineers ensure smooth data migration,
                  maintaining high availability and reducing downtime during the
                  process.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      {/* <div className="max-w-3xl mx-auto p-4 mt-10 w-full">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {AWSMigrationEngineersFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div> */}

       <div className="h-[30px] md:h-[60px] lg:h-[80px]"></div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16">
                FAQs
            </h2>
            <div className="flex flex-col md:flex-row justify-around mb-5  md:mb-4 lg:mb-5 item-center ">

                <div className="w-full  md:w-1/2 lg:w-[616px]  mb-8 md:mb-4 lg:mb-0">
                    {/* <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
                        FAQs
                    </h2> */}
                    {AWSMigrationEngineersFaqs.map((faq, index) => (
                        <div key={index} className="border-b-2 border-blue-300">
                            <button
                                onClick={() => toggleFAQ(index)}
                                className={` w-full text-left py-4 flex justify-between items-center focus:outline-none ${activeIndex === index
                                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                                    : ""
                                    }`}
                            >
                                <span className="text-lg">{faq.question}</span>
                                <span className="text-2xl">
                                    {activeIndex === index ? "-" : "+"}
                                </span>
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 text-gray-700">{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>

                <div id="contact-section" className="w-full md:w-1/2 lg:w-1/2">
                    {" "}
                    <Contact />
                </div>


            </div>

      <GetInTouch />
    </div>
  </>);
};

export default AWSMigrationEngineers;
